import { createSlice } from "@reduxjs/toolkit";

export const restaurantFeature = createSlice({
  name: "restaurant",
  initialState: {
    opening_hours: {
      monday: {
        open: "00:00",
        closed: "00:00",
      },
      friday: {
        open: "00:00",
        closed: "00:00",
      },
      saturday: {
        open: "00:00",
        closed: "00:00",
      },
      thursday: {
        open: "00:00",
        closed: "00:00",
      },
      tuesday: {
        open: "00:00",
        closed: "00:00",
      },
      wednesday: {
        open: "00:00",
        closed: "00:00",
      },
      sunday: {
        open: "00:00",
        closed: "00:00",
      },
    },
    day: ""
  },
  reducers: {
    addRestaurant: (state, action) => {
      console.log(
        "PERSISTED",
        restaurantFeature.name,
        addRestaurant.type,
        ":",
        state
      );
      console.log(
        "REDUX",
        restaurantFeature.name,
        addRestaurant.type,
        ":",
        action.payload
      );
      state = action.payload;
      return state;
    },

    updateHoursWorking: (state, action) => {
      console.log(action.payload);
      const nameKey = Object.keys(action.payload).shift();
      console.log(nameKey);
      switch (nameKey) {
        case "monday":
          state.opening_hours.monday = action.payload.monday;
          break;

        case "friday":
          state.opening_hours.friday = action.payload.friday;
          break;

        case "saturday":
          state.opening_hours.saturday = action.payload.saturday;
          break;

        case "sunday":
          state.opening_hours.sunday = action.payload.sunday;
          break;

        case "thursday":
          state.opening_hours.thursday = action.payload.thursday;
          break;

        case "wednesday":
          state.opening_hours.wednesday = action.payload.wednesday;
          break;

        case "tuesday":
          state.opening_hours.tuesday = action.payload.tuesday;
          break;
      }
      //   state.opening_hours.monday = action.payload;
      //   return state;
    },
    setDay:(state, action)=>{
      state.day = action.payload
    }
  },
});

export const { updateHoursWorking, addRestaurant, setDay } = restaurantFeature.actions;

export default restaurantFeature.reducer;
